import { SVGProps } from 'react';
import { SVGIconEyeOpen } from './SVGIconEyeOpen';
import { SVGIconEyeClose } from './SVGIconEyeClose';

export type SVGIconPasswordEyeProps = SVGProps<any>;

export default Object.assign(
  {},
  {
    Open: SVGIconEyeOpen,
    Close: SVGIconEyeClose,
  },
);
